/* eslint-disable no-nested-ternary */
const getPrimaryIncentiveImage = (incentive) => (
  incentive?.incentiveImage?.asset ? incentive.incentiveImage
    : (incentive?.heroImage?.asset ? incentive.heroImage
      : (incentive?.galleryImages && incentive.galleryImages[0] ? incentive.galleryImages[0]
        : undefined)));

export default getPrimaryIncentiveImage;
